import { LogisticsMap } from "../components/logistics/LogisticsMap";

export default function LogisticsMapPage() {
  return <LogisticsMap />;
}
